import { render, staticRenderFns } from "./SelectedMerchant.vue?vue&type=template&id=7d39ef44"
import script from "./SelectedMerchant.vue?vue&type=script&lang=js"
export * from "./SelectedMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports